import resetLocationFeedbackManager from 'owa-feedback-manager-actions/lib/actions/resetLocationFeedbackManager';
import { orchestrator } from 'satcheljs';
import { resetComposeStore, resetQuickComposeStore } from 'owa-calendar-compose-form-actions';

export default orchestrator(resetQuickComposeStore, actionMessage => {
    resetComposeStore();
    resetLocationFeedbackManager(); // We must reset the location feedback manager
});
